import React from 'react';

export interface ListActionItem {
  key: string;
  left: React.ReactNode;
  right?: React.ReactNode;
}

interface ListWithActionsProps {
  items: ListActionItem[];
  className?: string;
}

const ListWithActions: React.FC<ListWithActionsProps> = ({ items, className }) => {
  if (!items || items.length === 0) return null;
  return (
    <ul className={"divide-y rounded-md border border-cm-border-subtle " + (className ?? "")}> 
      {items.map((item) => (
        <li key={item.key} className="flex items-center justify-between py-2 px-3">
          <div className="min-w-0 flex-1">
            {item.left}
          </div>
          {item.right && (
            <div className="ml-3 flex-shrink-0">
              {item.right}
            </div>
          )}
        </li>
      ))}
    </ul>
  );
};

export default ListWithActions;
